import React from 'react';
import ContentLoader from 'react-content-loader';

import { createStyles, withStyles, WithStyles } from '@material-ui/core';

const styles = () =>
  createStyles({
    container: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    root: {
      width: 400,
    },
  });

export interface ContentLoaderReportsProps extends WithStyles<typeof styles> {}

const ContentLoaderReports: React.FC<ContentLoaderReportsProps> = ({ classes, ...rest }) => (
  <div className={classes.container}>
    <div className={classes.root} {...rest}>
      <ContentLoader width={400} height={400}>
        <rect x="0" y="160" rx="0" ry="0" width="50" height="40" />
        <rect x="60" y="125" rx="0" ry="0" width="50" height="75" />
        <rect x="120" y="106" rx="0" ry="0" width="50" height="94" />
        <rect x="180" y="60" rx="0" ry="0" width="50" height="140" />
        <rect x="240" y="122" rx="0" ry="0" width="50" height="78" />
      </ContentLoader>
    </div>
  </div>
);

export default withStyles(styles)(ContentLoaderReports);
